<template>
	<page gradient-background>
		<doc-base>
			<template #title>{{baseInfo.applicant_name}}_请假单</template>

			<template #info>
				<c-field label="单据编号">{{baseInfo.document_number}}</c-field>
			</template>
		</doc-base>

        <doc-content>
            <c-field label="请假类型"><c-state dict="leaveTypeDic" :value="baseInfo.leave_type"></c-state></c-field>
            <c-field label="开始时间">{{baseInfo.start_time}}</c-field>
            <c-field label="结束时间">{{baseInfo.end_time}}</c-field>
            <c-field label="请假时长"><b style="font-size: .32rem;">{{baseInfo.leave_duration}}{{baseInfo.leave_granularity == 2 ? '小时' : '天'}}</b></c-field>
            <c-field label="请假事由">{{baseInfo.reason}}</c-field>
            <c-field label="图片">
                <c-file-list :value="baseInfo.attachment_images"></c-file-list>
            </c-field>
        </doc-content>

		<doc-log ref="docLog" :form-id="baseInfo.form_id"></doc-log>

		<doc-handle
			ref="docHandle"
			flow="4"
			:order="id"
			:status="baseInfo.status"
			:applicant="baseInfo.is_founder == 1"
			:approver="baseInfo.is_approval == 1"
			@edit="mp.navigateWeb('/affairs/leave/edit', {id: baseInfo.id})"
			@delete="deleteHandle"
			@update="update"
		></doc-handle>
	</page>
</template>

<script>
	export default {
		props: {
			id: String
		},

		data() {
			return {
				baseInfo: {}
			}
		},

		mounted() {
			this.update();
			
			this.$onShow(() => {
				this.update();
				this.$refs.log.update();
			});
		},

		methods: {
			update() {
				this.request({
					url: '/leave/application/detail',
					data: {
						id: this.id
					},
					success: ({detailInfo, transaction}) => {
						this.baseInfo = detailInfo;
						this.$refs.docHandle.init(transaction);
					}
				});
			},

			deleteHandle() {
				this.$confirm({
					message: '确定要删除该单据吗',
					resolve: () => {
						this.request({
							url: '/leave/application/delete',
							data: {
								id: this.id
							},
							loading: true,
							success: () => {
								this.$message({
									message: '删除成功',
									mask: true
								});
								setTimeout(() => {
									this.mp.navigateBack();
								}, 1000);
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>